import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { logErrors } from 'utils';
/* ctpAsync exports the same name against the same URL but fills a different slice. */
import {
  fetchAvailableOffers as fetchPlanAvailableOffers,
  fetchPlanChangeEligibility,
} from 'services/plan/planAsync';
import {
  selectAvailableOffersLoaded,
  selectPlanChangeEligibilityLoaded,
} from 'services/plan/planSelectors';
import {
  selectIsNonPrimaryUser,
  selectUserId,
} from 'services/user/userSelectors';
import {
  selectIsPlanUpgradeSubmitted,
  selectIsUnlockInsuranceBrandPlan,
} from '../services/unlockInsuranceSelectors';

/**
 * Fetches the two plan-slice reads the unlock flow depends on. Gated to the eligible cohort,
 * so brands without an `unlockInsurance` entry issue no request at all.
 */
function useUnlockInsuranceBootstrap() {
  const dispatch = useAppDispatch();
  const isBrandPlan = useAppSelector(selectIsUnlockInsuranceBrandPlan);
  const isPlanUpgradeSubmitted = useAppSelector(selectIsPlanUpgradeSubmitted);
  const isNonPrimaryUser = useAppSelector(selectIsNonPrimaryUser);
  const userId = useAppSelector(selectUserId);
  const eligibilityLoaded = useAppSelector(selectPlanChangeEligibilityLoaded);
  const offersLoaded = useAppSelector(selectAvailableOffersLoaded);

  const shouldFetch =
    isBrandPlan && !isPlanUpgradeSubmitted && !!userId && !isNonPrimaryUser;

  useEffect(() => {
    if (!shouldFetch || eligibilityLoaded) return;

    const fetchEligibility = async () => {
      try {
        await dispatch(fetchPlanChangeEligibility());
      } catch (error) {
        logErrors(error);
      }
    };
    fetchEligibility();
  }, [shouldFetch, eligibilityLoaded]);

  useEffect(() => {
    if (!shouldFetch || offersLoaded) return;

    const fetchOffers = async () => {
      try {
        await dispatch(fetchPlanAvailableOffers());
      } catch (error) {
        logErrors(error);
      }
    };
    fetchOffers();
  }, [shouldFetch, offersLoaded]);
}

export default useUnlockInsuranceBootstrap;
